/* tslint:disable */

//  This file was generated from apps/appsync-bff/appsync/resources/schema.graphql
//  and should not be edited manually.

export const addBoidAssignment = /* GraphQL */ `
  mutation AddBoidAssignment($assignment: BoidAssignmentInput) {
    result: addBoidAssignment(boidAssignment: $assignment) {
      success
    }
  }
`;

export const removeBoidAssignment = /* GraphQL */ `
  mutation RemoveBoidAssignment($assignment: BoidAssignmentInput) {
    result: removeBoidAssignment(boidAssignment: $assignment) {
      success
    }
  }
`;

export const updateOperationalEntityBusinessStatus = /* GraphQL */ `
  mutation UpdateOperationalEntityBusinessStatus($statusInput: UpdateBusinessStatusInput) {
    entity: updateOperationalEntityBusinessStatus(statusInput: $statusInput) {
      success
    }
  }
`;

export const updateOperationalEntityOems = /* GraphQL */ `
  mutation UpdateOperationalEntityOems($oemInput: UpdateOemsInput) {
    entity: updateOperationalEntityOems(oemInput: $oemInput) {
      success
    }
  }
`;

export const setEntitlementStatus = /* GraphQL */ `
  mutation SetEntitlementStatus($enterpriseEntitlement: EnterpriseEntitlementInput) {
    entity: setEntitlementStatus(enterpriseEntitlement: $enterpriseEntitlement) {
      success
    }
  }
`;

export const updateOperationalEntitySources = /* GraphQL */ `
  mutation UpdateOperationalEntitySources($sourcesInput: UpdateSourcesInput) {
    result: updateOperationalEntitySources(sourcesInput: $sourcesInput) {
      success
    }
  }
`;

export const updateOperationalEntityTelecomNumbers = /* GraphQL */ `
  mutation UpdateOperationalEntityTelecomNumbers($telecomNumbersInput: UpdateTelecomNumbersInput) {
    result: updateOperationalEntityTelecomNumbers(telecomNumbersInput: $telecomNumbersInput) {
      success
    }
  }
`;

export const updateOperationalEntityDbaName = /* GraphQL */ `
  mutation UpdateOperationalEntityDbaName($dbaNameInput: UpdateDbaNameInput) {
    entity: updateOperationalEntityDbaName(dbaNameInput: $dbaNameInput) {
      success
    }
  }
`;

export const updateOperationalEntityAddress = /* GraphQL */ `
  mutation UpdateOperationalEntityAddress($addressInput: UpdateAddressInput) {
    entity: updateOperationalEntityAddress(addressInput: $addressInput) {
      success
    }
  }
`;

export const updateOperationalEntityParent = /* GraphQL */ `
  mutation UpdateOperationalEntityParent($parentInput: UpdateParentInput) {
    entity: updateOperationalEntityParent(parentInput: $parentInput) {
      success
    }
  }
`;

export const updateOperationalEntityParentV2 = /* GraphQL */ `
  mutation UpdateOperationalEntityParentV2($parentInput: UpdateParentInput) {
    result: updateOperationalEntityParentV2(parentInput: $parentInput) {
      entity {
        id
        sources {
          sourceId
          sourceType
        }
        boidAssignments {
          businessOperationType
          businessOperationId
          commonOrgId
        }
        organizationInformation {
          dbaName
          legalName
          status
          telecomNumbers
          address {
            streetAddressLine1
            streetAddressLine2
            city
            state
            zip
            country
          }
        }
        oems {
          abbreviation
          id
          locationId
          nameplateDescription
        }
        parent {
          id
          organizationInformation {
            dbaName
          }
          statuses
        }
        statuses
        enterpriseEntitlementsV2 {
          featureName
          featureId
          status
        }
        isComplex
        tenantId
      }
    }
  }
`;

export const createOperationalEntity = /* GraphQL */ `
  mutation CreateOperationalEntity($operationalEntity: OperationalEntityInput) {
    entity: createOperationalEntity(operationalEntity: $operationalEntity) {
      transactionId
      id
      dbaName
      sources {
        sourceId
        sourceType
      }
      status
      message
    }
  }
`;

export const createOperationalEntityWithTenant = /* GraphQL */ `
  mutation CreateOperationalEntityWithTenant($createOEInput: CreateOperationalEntityWithTenantInput!) {
    createOEResult: createOperationalEntityWithTenant(input: $createOEInput) {
      transactionId
      id
      dbaName
      sources {
        sourceId
        sourceType
      }
      message
      status
    }
  }
`;

export const createTenant = /* GraphQL */ `
  mutation CreateTenant($input: CreateTenantInput!) {
    createTenant(input: $input) {
      tenant {
        id
        name
      }
    }
  }
`;

export const submitSupportRequest = /* GraphQL */ `
  mutation SubmitSupportRequest($input: SupportRequestInput!) {
    submitSupportRequest(input: $input) {
      messageId
    }
  }
`;

export const createSimpleOperationalHierarchyV2 = /* GraphQL */ `
  mutation CreateSimpleOperationalHierarchyV2($input: CreateHierarchyNodeInput!) {
    result: createSimpleOperationalHierarchyV2(input: $input) {
      ...OperationalEntityResultNodeV2
      children {
        ...OperationalEntityResultNodeV2
        children {
          ...OperationalEntityResultNodeV2
          children {
            ...OperationalEntityResultNodeV2
            children {
              ...OperationalEntityResultNodeV2
              children {
                ...OperationalEntityResultNodeV2
                children {
                  ...OperationalEntityResultNodeV2
                  children {
                    ...OperationalEntityResultNodeV2
                    children {
                      ...OperationalEntityResultNodeV2
                      children {
                        ...OperationalEntityResultNodeV2
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment OperationalEntityResultNodeV2 on CreateOperationalEntityData {
    id
    sources {
      sourceId
      sourceType
    }
    dbaName
    status
    message
    tenantId
  }
`;
